const wonders = [ 
	{
		id:1,
		image : "images/Birds/Keel-billed Toucan.jpg",
		name : "Keel billed Toucan",
		category : "birds",
		description : "The size of the bill can be fairly deceptive as to its weight. Although it seems heavy, it’s light and hollow. They use these colorful beaks to lure females particularly in the breeding season and also for self-defense."
	},

	{
		id:2,
		image : "images/Birds/Hyacinth Macaw.jpg",
		name : "Hyacinth Macaw",
		category : "birds",
		description : "The wingspan spreads out to four feet, making for a truly majestic specimen regardless of its gorgeous coloring. Apart from the stunning cobalt blue feathers, you can identify the hyacinth macaw by its arched black bill and charming long tail."
	},

	{
		id:3,
		image : "images/Birds/Wood Duck.jpg",
		name : "Wood Duck",
		category : "birds",
		description : "The male wood ducks are more stunning than their female counterparts. Males have a metallic green head and crest with tints of purple attractively sprinkled. Their necks are decorated with beautiful tapering white stripes."
	},

	{
		id:4,
		image : "images/Birds/Bohemian Waxwing.jpg",
		name : "Bohemian Waxwing",
		category : "birds",
		description : "The bohemian waxwing is medium-sized bird with a signature crested head and distinctive black mask. They’re mostly greyish brown with cinnamon-hued under-tail plumage and yellow-tipped tails. The red-colored feather edges beautify this passerine."
	},

	{
		id:5,
		image : "images/Birds/Blue Jay.jpg",
		name : "Blue Jay",
		category : "birds",
		description : "Blue jays offer beauty with brains, as they are considered amongst the most intelligent birds in the world. It’s easy to spot them by their distinctive “jay jay” sounding calls. Blue jays have a colorful plumage that consists of a clever combination of blue, black, and white."
	},

	{
		id:6,
		image : "images/Birds/Blue Jay.jpg",
		name : "Blue Jay",
		category : "birds",
		description : "Blue jays offer beauty with brains, as they are considered amongst the most intelligent birds in the world. It’s easy to spot them by their distinctive “jay jay” sounding calls. Blue jays have a colorful plumage that consists of a clever combination of blue, black, and white."
	},

	{
		id:6,
		image : "images/Flower/bougainvillea.jpg",
		name : "Bougainvillea",
		category : "flowers",
		description : "A favorite in tropical locales, this colorful climber can also be grown annually if you don't happen to live in a sunny spot. Bougainvillea can grow 20–30 feet tall and wide, and its beautiful color-saturated flowers make a major impact."
	},
	
	{
		id:7,
		image : "images/Flower/wisteria.jpg",
		name : "Wisteria",
		category : "flowers",
		description : "If there was ever a flower to make you feel like you've wandered into a Jane Austen novel, wisteria is it. Not only does this climbing vine look romantic, it smells amazing too and will fill the space with color and fragrance. Be sure to opt for a North American species if you live in the states."
	},
	{
		id:8,
		image : "images/Flower/Cosmos.jpg",
		name : "Cosmos",
		category : "flowers",
		description : "Wispy and delicate, these daisy-shaped flowers seem almost weightless stop their super-long stems (which can grow up to 60 inches tall! Stake them for added support). Wedding florists love to tuck them into otherwise staid bouquets for a bit of happy whimsy; you should do the same for tabletop arrangements."
	},

	{
		id:9,
		image : "images/Flower/Alstroemerias.jpg",
		name : "Alstroemerias",
		category : "flowers",
		description : "Typically called Peruvian lilies, they come in bright colors like pink, orange, and purple. Alstroemerias easy to grow and don't require a ton of care. Great for flower bouquets, they last up to two weeks once cut."
	},

	{
		id:10,
		image : "images/Flower/Rose.jpg",
		name : "Rose",
		category : "flowers",
		description : "With hundreds of species, roses bloom in a myriad of beautiful colors. These romantic flowers aren't just for Valentine's Day—they'll look gorgeous in your garden. Plant them where they'll get enough morning sun, and make sure to water them diligently."
	},


	{
		id:11,
		image : "images/Food/massaman-curry.jpg",
		name : "Massaman curry",
		category : "foods",
		description : "Emphatically the king of curries, and perhaps the king of all foods. Spicy, coconutty, sweet and savory. Even the packet sauce you buy from the supermarket can make the most delinquent of cooks look like a Michelin potential. Thankfully, someone invented rice, with which diners can mop up the last drizzles of curry sauce. The Land of Smiles isn't just a marketing catch-line. It's a result of being born in a land where the world's most delicious food is sold on nearly every street corner."
	},


	{
		id:12,
		image : "images/Food/Neapolitan pizza.jpg",
		name : "Neapolitan pizza",
		category : "foods",
		description : "Spare us the lumpy chain monstrosities and everything-on-it wheels of greed. The best pizza was and still is the simple Neapolitan, an invention now protected by its own trade association that insists on sea salt, high-grade wheat flour, the use of only three types of fresh tomatoes, hand-rolled dough and the strict use of a wood-fired oven, among other quality stipulations. "
	},

	{
		id:13,
		image : "images/Food/chocolate.jpg",
		name : "Chocolate",
		category : "foods",
		description : "The Mayans drank it, Lasse Hallström made a film about it and the rest of us get over the guilt of eating too much of it by eating more of it. The story of the humble cacao bean is a bona fide out-of-the-jungle, into-civilization tale of culinary wonder. Without this creamy, bitter-sweet confection, Valentine's Day would be all cards and flowers, Easter would turn back into another dull religious event."
	},

	{
		id:14,
		image : "images/Food/penang-assam-laksa-malaysia.jpg",
		name : "Penang assam laksa",
		category : "foods",
		description : "Poached, flaked mackerel, tamarind, chili, mint, lemongrass, onion, pineapple ... one of Malaysia's most popular dishes is an addictive spicy-sour fish broth with noodles (especially great when fused with ginger), that'll have your nose running before the spoon even hits your lips."
	},

	{
		id:15,
		image : "images/Food/Tom yum goong.jpg",
		name : "Tom yum goong",
		category : "foods",
		description : "This best food Thai masterpiece teems with shrimp, mushrooms, tomatoes, lemongrass, galangal and kaffir lime leaves. Usually loaded with coconut milk and cream, the hearty soup unifies a host of favorite Thai tastes: sour, salty, spicy and sweet. Best of all is the price: cheap."
	}
]

export default wonders;